declare const polyrhythmModeBrand: unique symbol;

export const minPolyrhythmCount = 2;
export const maxPolyrhythmCount = 13;

const POLYRHYTHM_RATIO_PATTERN = /^polyrhythm-([1-9]\d*)-([1-9]\d*)$/;

export type PolyrhythmMode = `polyrhythm-${number}-${number}` & {
  readonly [polyrhythmModeBrand]: true;
};

export interface PolyrhythmRatio {
  pulses: number;
  beats: number;
}

export function greatestCommonDivisor(left: number, right: number): number {
  let a = Math.abs(Math.round(left));
  let b = Math.abs(Math.round(right));
  while (b !== 0) {
    const remainder = a % b;
    a = b;
    b = remainder;
  }
  return Math.max(1, a);
}

export function parsePolyrhythmMode(value: string): PolyrhythmRatio | null {
  const match = value.match(POLYRHYTHM_RATIO_PATTERN);
  if (!match) {
    return null;
  }

  const pulses = Number(match[1]);
  const beats = Number(match[2]);
  if (
    !Number.isInteger(pulses)
    || !Number.isInteger(beats)
    || pulses === beats
    || pulses < minPolyrhythmCount
    || beats < minPolyrhythmCount
    || pulses > maxPolyrhythmCount
    || beats > maxPolyrhythmCount
    || greatestCommonDivisor(pulses, beats) !== 1
  ) {
    return null;
  }

  return { pulses, beats };
}

export function isPolyrhythmMode(value: string): value is PolyrhythmMode {
  return parsePolyrhythmMode(value) !== null;
}

export function createPolyrhythmMode(pulses: number, beats: number): PolyrhythmMode | null {
  const value = `polyrhythm-${pulses}-${beats}`;
  return isPolyrhythmMode(value) ? value : null;
}
